
import React from 'react';

const CoreAdvantagesSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">核心服务</h2>
          <p className="text-xl text-gray-600">三大核心服务,助您实现职业梦想</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl text-center">
            <h3 className="text-3xl font-bold text-blue-600 mb-4" style={{ fontSize: '2em' }}>百万年薪求职规划</h3>
            <p className="text-gray-700 text-lg leading-relaxed">
              搭乘产业革命浪潮的求职辅导
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl text-center">
            <h3 className="text-3xl font-bold text-green-600 mb-4" style={{ fontSize: '2em' }}>金牌实习直录取</h3>
            <p className="text-gray-700 text-lg leading-relaxed">
              独家抢跑式岗位内推
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-xl text-center">
            <h3 className="text-3xl font-bold text-purple-600 mb-4" style={{ fontSize: '2em' }}>前程更好的留学+</h3>
            <p className="text-gray-700 text-lg leading-relaxed">
              以更好职业前景为目标的留学规划
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreAdvantagesSection;
